export default __webpack_public_path__ + "static/media/reporte-m.cef8b081.svg";